import { useEffect } from "react";
import { Link } from "react-router-dom";

export const WEEKLY_THRESHOLD_GUIDE_ID = "wochen-ueberstundengrenze";

/** Customer-facing instructions, separate from generated test evidence. */
export function WeeklyThresholdGuide() {
  useEffect(() => {
    if (window.location.hash === `#${WEEKLY_THRESHOLD_GUIDE_ID}`) {
      document.getElementById(WEEKLY_THRESHOLD_GUIDE_ID)?.scrollIntoView({ block: "start" });
    }
  }, []);

  return (
    <section id={WEEKLY_THRESHOLD_GUIDE_ID} className="doc-chapter open" style={{ scrollMarginTop: 80 }} aria-labelledby="weekly-threshold-guide-title">
      <div className="doc-chapter-body">
        <h2 id="weekly-threshold-guide-title">Individuelle Wochen-Überstundengrenze</h2>
        <p>
          Für einen einzelnen Mitarbeiter kann eine andere Wochen-Grenze hinterlegt werden,
          zum Beispiel 40 statt 42 Stunden. Ohne individuelle Einstellung gilt weiterhin
          der Standard des ausgewählten Mandanten. Die Ausnahme ersetzt nur die Wochen-Grenze
          für Überstunden mit 50 % Zuschlag. Soll-Arbeitszeit, Tagesgrenze, Zuschlag und
          Zahlungsart bleiben unverändert.
        </p>

        <h3>Individuelle Grenze einstellen</h3>
        <ol>
          <li>Wähle den richtigen Mandanten und öffne <Link to="/settings/employees#weekly-threshold">Einstellungen → Mitarbeiter</Link>.</li>
          <li>Suche den Mitarbeiter. Klicke in der Spalte <strong>Wochen-Überstundengrenze</strong> auf seinen angezeigten Wert, zum Beispiel „42 h · Standard“.</li>
          <li>Entferne das Häkchen bei <strong>Standard verwenden</strong> und trage unter <strong>Individuelle Grenze (h/Woche)</strong> den vereinbarten Wert ein.</li>
          <li>Wähle bei <strong>Gültig ab Monat</strong> den ersten betroffenen Abrechnungsmonat. Bleibt das Feld leer, gilt die Ausnahme <strong>ab Beginn</strong>, also auch für vorhandene frühere Monate.</li>
          <li>Klicke auf <strong>Speichern</strong>. Danach zeigt die Spalte den Wert mit „Individuell“ und gegebenenfalls den Beginn. <strong>Abbrechen</strong> verwirft ungespeicherte Änderungen.</li>
        </ol>
        <p className="muted">
          Die Spalte erscheint nur bei Mandanten mit Stunden-/Überstundenberechnung.
          Den geltenden Standard und den Hinweis auf individuelle Ausnahmen findest du
          unter <Link to="/settings/client-rules">Einstellungen → Mandant-Regelwerk</Link>.
        </p>

        <h3>Zum Standard zurückkehren</h3>
        <p>
          Öffne den Wert erneut, wähle <strong>Auf Standard zurücksetzen</strong> oder
          aktiviere <strong>Standard verwenden</strong>. Lege den Gültigkeitsbeginn fest
          und klicke auf <strong>Speichern</strong>. Ab diesem Beginn gilt wieder der
          Mandantenstandard. Mit einem ausgewählten Monat bleiben frühere Zeiträume
          unverändert; ohne Monat gilt das Rücksetzen ab Beginn.
        </p>

        <h3>Was passiert mit bestehenden Berechnungen?</h3>
        <p>
          Neue Berechnungen verwenden die für ihren Monat gültige Grenze. Bereits gespeicherte
          historische Berechnungen werden durch das Speichern der Einstellung <strong>nicht
          automatisch überschrieben</strong>. Wurde eine andere Grenze verwendet, zeigt die
          Karte einen Hinweis auf die veraltete Berechnung. Der reguläre Export dieser
          Berechnung ist bis zur geprüften Neuberechnung gesperrt.
        </p>
        <p>
          Prüfe zuerst die betroffenen Monate und bereits in der Lohnverrechnung übernommenen
          oder manuell korrigierten Werte. Stimme anschließend die gezielte Neuberechnung
          ab. Die Einstellung verändert keine bereits übernommenen Buchungen im
          nachgelagerten System.
        </p>

        <h3>ZA-Saldo und Überstunden getrennt lesen</h3>
        <p>
          Separat ausgewiesene Überstunden mit 50 % Zuschlag sind nicht zusätzlich im
          getrennten ZA-Saldo enthalten. Eine niedrigere individuelle Wochen-Grenze kann
          Stunden vom getrennten ZA-Saldo zu den Überstunden verschieben. Diese Zusatzwirkung
          ist vom behobenen ZA-Berechnungsfehler zu unterscheiden; beim ZA-Bugfix allein
          bleiben die ausgewiesenen Überstunden unverändert.
        </p>
      </div>
    </section>
  );
}
